import axios from '../../admin-axios';
import ActionType from '../action-types';

// eslint-disable-next-line import/prefer-default-export
export const getDesignations = () => {
  return async (dispatch) => {
    dispatch({
      type: ActionType.FETCH_DESIGNATION_START
    });

    try {
      // send request to get current user
      const response = await axios.get(`https://gasflow.africa/v1/api/staff/designation`);
      dispatch({
        type: ActionType.FETCH_DESIGNATION_SUCCESS,
        payload: { data: response.data.data } // response data
      });
    } catch (error) {
      let message = 'Something went wrong';

      if (error?.response) {
        if (Array.isArray(error.response.data?.message)) {
          message = error.response.data.message.join('\n');
        } else {
          message = error?.response.data?.message;
        }
      }
      if (!message) {
        message = 'Something went wrong';
      }
      dispatch({
        type: ActionType.FETCH_DESIGNATION_ERROR,
        payload: message
      });
    }
  };
};
